import ApplicationSerializer from "./application";

export default class InstanceUserSerializer extends ApplicationSerializer {
  primaryKey = "userid";
}
